import { useCallback as d } from "react";
import R from "react-dom";
import { fileToObject as I, getValidationErrors as Z, findFileInList as L } from "./utils3.mjs";
import { EDropzoneFileStatus as f } from "./types.mjs";
import { isDefined as c, isTruthy as q } from "./types3.mjs";
import { useDropzoneValidation as A } from "./useDropzoneValidation.mjs";
import { useControlledState as G } from "./useControlledState.mjs";
import "./_root.mjs";
import "./_baseGetTag.mjs";
import "@mui/material";
const a = R.flushSync, P = ({
  defaultFileList: E = [],
  onProgress: F,
  onStart: U,
  onSuccess: y,
  onError: D,
  onChange: o,
  onDelete: x,
  ref: j,
  validation: z,
  isMultiple: O,
  fileListOuter: T
}) => {
  const [m, p] = G({
    value: T,
    defaultValue: E ? () => E.map((t) => {
      const r = { ...t };
      return r.status = t.status ?? f.Done, r;
    }) : void 0
  }), S = A({
    fileList: m,
    validation: z
  }), b = d(
    (t, r, e) => {
      c(D) && D(t, r, e);
    },
    [D]
  ), _ = d(
    (t, r) => {
      const e = I(t), s = S(e, r), u = s.length > 0;
      return u ? (e.status = f.Error, e.error = s.map((i) => Z(i, { ...z })).join(". "), b(new Error(e.error), {}, e), c(o) && o(e, m)) : !O && q(m.length) && p([]), !u;
    },
    [
      S,
      b,
      o,
      z,
      m,
      O,
      p
    ]
  ), k = d(
    (t) => {
      const r = () => p((e) => {
        const s = I(t);
        s.status = f.Uploading;
        const u = [...e, s];
        return c(U) && U(t), c(o) && o(s, u), u;
      });
      if (a) {
        a(r);
        return;
      }
      r();
    },
    [p, U, o]
  ), v = d(
    (t, r) => {
      const e = () => p((s) => {
        const u = L(r, s);
        if (!c(u))
          return s;
        const i = {
          ...u,
          size: r.size,
          name: r.name,
          type: r.type,
          percent: t.percent ? parseInt(t.percent.toFixed(0)) : 0
        }, n = s.map((l) => l.uid === r.uid ? i : l);
        return c(F) && F(t, i), c(o) && o(i, n), n;
      });
      if (a) {
        a(e);
        return;
      }
      e();
    },
    [p, F, o]
  ), w = d(
    (t, r, e) => {
      const s = () => p((u) => {
        const i = L(r, u);
        if (!c(i))
          return u;
        const n = {
          ...i,
          status: f.Done
        }, l = u.map((V) => V.uid === r.uid ? n : V);
        return c(y) && y(t, n, e), c(o) && o(n, l), l;
      });
      if (a) {
        a(s);
        return;
      }
      s();
    },
    [p, y, o]
  ), B = d(
    (t) => {
      j?.current?.abort(t), p((r) => {
        const e = r.filter((s) => s.uid !== t.uid);
        return c(o) && o(t, e), c(x) && x(t, e), e;
      });
    },
    [o, x, j, p]
  );
  return {
    fileList: m,
    setFileList: p,
    handleUploadProgress: v,
    handleUploadStart: k,
    handleUploadSuccess: w,
    handleUploadError: b,
    handleUploadDelete: B,
    handleUploadBefore: _
  };
};
export {
  P as useDropzoneState
};
//# sourceMappingURL=useDropzoneState.mjs.map
